import posthog, { PostHogConfig } from "posthog-js";
import { IEvent } from "../lib/eventing/events";
import { AppEventBus } from "./appEventBus";

export type PosthogServiceConfig = {
    apiKey: string,
    apiHost: string,
    options: Partial<PostHogConfig>,
}

export function initialisePosthog(config:PosthogServiceConfig, eventBus:AppEventBus) {
    posthog.init(
        config.apiKey,
        {
            api_host: config.apiHost,
            defaults: '2025-05-24',
            ...config.options
        }
    );

    eventBus.namespaces.excel.events.userIdentified.on((payload) => {
        posthog.identify(payload.id, {
            name: payload.username,
            email: payload.email
        });
    });

    const capture = (event: IEvent, type?:string) => {
        posthog.capture(type??event.type, event.payload);
    };

    // all excel and workbookClassification events
    eventBus.on(["excel","workbookClassification"], (_, event) => capture(event));

    // Navigation events
    eventBus.namespaces.navigation.events.navigation.on((_, event) => capture(event, "$pageview"));
}